<template>
    <v-dialog v-model="dialog" scrollable max-width="400px">
        <template v-slot:activator="{ on:dialog }">
            <v-tooltip top>
                <template v-slot:activator="{ on:tooltip }">
                    <v-btn color="primary"
                           x-small
                           fab
                           class="mx-2"
                           depressed
                           v-on="{...dialog, ...tooltip}"
                    >
                        <v-icon>mdi-calendar-check</v-icon>
                    </v-btn>
                </template>
                <span>История посещений</span>
            </v-tooltip>
        </template>
        <v-card class="modal-card">
            <v-card-title class="pa-6">История посещений</v-card-title>
            <v-card-text class="pa-6" style="min-height: 200px;max-height: 300px">
                <ul v-if="visits.length" class="visit-list">
                    <li v-for="visit in visits" :key="visit.id" class="list-item">
                        <span>{{ $dayjs(visit.created_at).format('DD MMMM YYYY в HH:mm') }}</span>
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                                <v-btn @click.prevent="remove(visit)"
                                       color="error"
                                       x-small
                                       fab
                                       depressed
                                       icon
                                       v-on="on"
                                >
                                    <v-icon>mdi-delete</v-icon>
                                </v-btn>
                            </template>
                            <span>Удалить посещение</span>
                        </v-tooltip>
                    </li>
                </ul>
                <div v-else-if="!visits.length && !visitsUpdate" class="text-center">
                    <v-progress-circular indeterminate></v-progress-circular>
                </div>
                <div v-else class="text-center">Посещения отсутствуют</div>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions class="px-6 py-5">
                <v-spacer></v-spacer>
                <v-btn depressed dark color="blue-grey" @click="dialog = false" min-width="120">Закрыть</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    import cardApi from '../api/card.api';
    import visitApi from '../api/visit.api';

    export default {
        name   : "CardVisitsDialog",
        props  : {
            card: {
                required: true,
                type    : Object,
            }
        },
        data() {
            return {
                dialog      : false,
                visits      : [],
                visitsUpdate: false
            }
        },
        watch  : {
            dialog() {
                if (true === this.dialog) {
                    this.visits = [];
                    this.visitsUpdate = false;
                    cardApi.visits(this.card.id).then(({data}) => {
                        this.visits = data.data;
                    }).catch(() => {
                        this.$toast.error('Что-то пошло не так. Пожалуйста, повторите попытку позже');
                    }).finally(() => {
                        this.visitsUpdate = true;
                    });
                }
            }
        },
        methods: {
            async remove(visit) {
                const confirmed = await this.$confirm('Вы уверены что хотите удалить это посещение?');
                if (false === confirmed) {
                    return;
                }

                this.$store.commit('setLoading', true);

                visitApi.delete(visit.id).then(() => {
                    this.$store.dispatch('clients/refresh');
                    this.visits.splice(this.visits.indexOf(visit), 1);
                    this.$emit('visit-deleted', visit.id);
                }).catch(() => {
                    this.$toast.error('Что-то пошло не так. Пожалуйста, повторите попытку позже');
                }).finally(() => {
                    this.$store.commit('setLoading', false);
                });
            }
        }
    }
</script>

<style scoped lang="scss">

    .visit-list {
        list-style: none;
        padding: 0;

        .list-item {
            display: flex;
            flex-wrap: nowrap;
            align-items: center;
            justify-content: space-between;
            padding: 4px 4px 4px 10px;

            &:hover {
                background-color: #f5f5f5;
            }

            + .list-item {
                border-top: 1px solid #eee;
            }
        }
    }
</style>
